import { useTranslation } from "react-i18next"
import styled from "styled-components"

const CrmTotal = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    gap: 1rem;
    width: 100%;
`

const CrmTotalBg =styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: ${p => p.theme.high};
    border-bottom-right-radius: var(--smallRadius);
    border-bottom-left-radius: var(--smallRadius);
    border-top: 2px solid ${p => p.theme.color};
    opacity: .6;
`

const CrmTotalColumn = styled.div`
    width: 100%;
    padding: var(--normalPads);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.6rem;
`

const CrmTotalMetric = styled.div`
    position: relative;
    z-index: 1;

    h6 {
        opacity: 0.75;
        margin-bottom: 0.4rem;
    }

    &:last-child {
        text-align: right;
    }
`

export default function Crm_Total(props) {
    const {t} = useTranslation();

  return (
    <CrmTotal>
        <CrmTotalBg></CrmTotalBg>
        <CrmTotalColumn>
            <CrmTotalMetric>
                <h6>{t("Leads")}</h6>
                <h5>{props.leadCount ?? 0}</h5>
            </CrmTotalMetric>
            <CrmTotalMetric>
                <h6>{t("Total")}</h6>
                <h5>€ {props.total}</h5>
            </CrmTotalMetric>
        </CrmTotalColumn>
    </CrmTotal>
  )
}
